
// const server = "http://127.0.0.1:3001"
const server = "https://calidig-apis.calidig.com"

export default server;
